import { OA_SHARES_DATA } from 'services/OpenAccessService';

export const shareQueryKeys = {
    all: [OA_SHARES_DATA],
    restrictions: [OA_SHARES_DATA, 'Restrictions'],
    activeCount: [OA_SHARES_DATA, 'ActiveCount']
};
